import React from "react";
import Header from "../../Components/Header/Header";
import EditDeck from "../../Components/YourDecks/EditDeck/EditDeck";

const EditYourDeck = () => {
  return (
    <div>
      <Header />
      <EditDeck />
    </div>
  );
};

export default EditYourDeck;
